import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: '/api/inferior/reason',
    name: 'defectCategoryPOST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
